"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BrightnessCorrectionWriter = void 0;
const gamma_brightnessCorrection_1 = require("../brightnessCorrection/gamma.brightnessCorrection");
function writeGammaBrightnessCorrection(brightnessCorrection) {
    const state = brightnessCorrection.state;
    const exponent = state.exponent;
    return {
        id: state.id,
        tag: 'gamma',
        exponent
    };
}
class BrightnessCorrectionWriter {
    static write(brightnessCorrection) {
        if (gamma_brightnessCorrection_1.CollectionModelGammaBrightnessCorrection.isGamma(brightnessCorrection)) {
            return writeGammaBrightnessCorrection(brightnessCorrection);
        }
        throw new Error(`Unexpected drawable: ${brightnessCorrection.id}:${brightnessCorrection.state.tag}`);
    }
}
exports.BrightnessCorrectionWriter = BrightnessCorrectionWriter;
//# sourceMappingURL=collection.model.write.brightnessCorrection.js.map